export default [
    {
        path: '/services/other',
        name: 'services.other',
        component: () => import('@/views/dashboard/otherServices/OtherServicesSummary.vue'),
        meta: { 
            service: 'other',
            smallMenu: true,
            active: 'other'
        },
    },

    // LEADS INDEX
    {
        path: '/services/other/leads',
        name: 'services.other.leads',
        component: () => import('@/views/dashboard/LeadsIndex.vue'),
        meta: { 
            service: 'other',
            type: 'lead',
            smallMenu: true,
            active: 'other'
        },
    },
    // LEADS SINGLE
    {
        path: '/services/other/leads/view/:reference?',
        name: 'services.other.leads.view',
        component: () => import('@/views/dashboard/LeadSingle.vue'),
        meta: {
            service: 'other',
            type: 'lead',
            smallMenu: true,
            active: 'other',
        }
    },

    // QUOTES INDEX
    {
        path: '/services/other/quotes',
        name: 'services.other.quotes',
        component: () => import('@/views/dashboard/otherServices/OtherServicesQuotesIndex.vue'),
        meta: { 
            service: 'other',
            type: 'quote',
            smallMenu: true,
            active: 'other'
        },
    },
    // QUOTES SINGLE
    {
        path: '/services/other/quotes/view/:reference?',
        component: () => import('@/views/layouts/SingleQuoteWrapper.vue'),
        props: true,
        meta: { 
            service: 'other',
            type: 'quote',
            smallMenu: true,
            active: 'other'
        },
        children: [
            {
                path: '',
                name: 'services.other.quote.view',
                component: () => import('@/components/services/QuoteDetailsTab.vue'),
                props: true,
            },
            {
                path: 'summary',
                name: 'services.other.quote.view.summary',
                component: () => import('@/components/dashboard/otherServices/OtherServicesQuoteSummary.vue'),
                props: true,
            },
            {
                path: 'fees',
                name: 'services.other.quote.view.fees',
                component: () => import('@/components/dashboard/misc/QuoteMatterFeesTab.vue'),
                props: true,
            },
            {
                path: 'activity',
                name: 'services.other.quote.view.activity',
                component: () => import('@/components/dashboard/misc/QuoteMatterActivityTab.vue'),
                props: true,
            },
        ],
    },

    // // MATTERS INDEX
    // {
    //     path: '/services/other/matters',
    //     name: 'services.other.matters',
    //     component: () => import('@/views/dashboard/otherServices/OtherServicesMattersIndex.vue'),
    //     meta: { 
    //         service: 'other',
    //         type: 'matter',
    //         smallMenu: true,
    //         active: 'other'
    //     },
    // },
]